module.exports = exports = require('./brukerconverter').convert;
exports.test = require('./brukerconverter').test;



/*****************
 ** WEBPACK FOOTER
 ** ./src/index.js
 ** module id = 0
 ** module chunks = 0
 **/